import { APPLICATION_ID, ENTITY_ID, PRODUCT_ID, SUPPLIER_ID } from "./constants";

export const formatDecimalCurrency = (value) => {
  // en-US  es-CO
  if (value === 0 || value === undefined) return value;
  const price = Number(value).toLocaleString("en-CO");
  return price;
};

export const years = () => {
  const year = new Date().getFullYear() - 18;
  let yearList = [];
  for (let index = 0; index < 81; index++) {
    yearList.push({ value: year - index, text: year - index });
  }
  return yearList;
};

export const yearsUp = () => {
  const year = new Date().getFullYear();
  const yearList = [];
  for (let index = 0; index < 30; index++) {
    yearList.push({ value: year + index });
  }
  return yearList;
};

export function calculateAmount(obj) {
  let amount = 0;
  if (obj.length > 0) {
    obj.forEach((item) => {
      amount = amount + (parseInt(item.product.value))
    });
  }
  return amount.toFixed(2);
}

export const splitDate = (date) => {
  return date.split("T")[0]
}

export const splitTime = (date) => {
  return date.split(".")[0]
}

export const validateResponseStatus = (response) => {
  if (response?.status === 401 || response?.status === 403) {
    /* Un 401/403 solo debe expulsar al usuario cuando HABÍA una
       sesión real (userInfoQursiva). En invitado (solo iboInfo o
       contact) significa que la request no debió lanzarse — el
       gateway rechaza porque no hay cookie `user-tk`. Antes se
       limpiaba TODO y se redirigía a `/`, lo que sacaba al invitado
       de su estado al primer endpoint con `auth:true` que se
       colara: guardas el prospecto → detalle monta → useEvaluation
       hace POST con auth → 401 → home. Ahora silenciamos ese caso;
       el llamador ya trata la ausencia de datos (array vacío,
       skeleton) sin desloguear a nadie. */
    const hadRealSession = Boolean(localStorage.getItem("userInfoQursiva"));
    if (!hadRealSession) return;

    /* Si el request salió SIN Authorization (porque getUserToken()
       devolvió falsy por un race post-login), el 401 es ruido del
       cliente y NO sesión caída: tenemos userInfoQursiva en localStorage
       con el token, pero una query en vuelo salió antes de que la cookie
       reflejara. El request interceptor de axios-dpop marca estos con
       __dpopSentWithoutAuth = true. Si vemos la marca, NO desloguear:
       el componente ve `return []` y la sesión queda intacta. Las
       siguientes queries, con el token ya reflejado, van a entregar
       datos reales. */
    if (response?.config?.__dpopSentWithoutAuth === true) return;

    localStorage.removeItem("iboInfo");
    localStorage.removeItem("contact");
    localStorage.removeItem("userInfoQursiva");
    if (window.location.pathname !== "/") {
      window.location.href = "/";
    }
  }
};

export const generateRqtMembershipBuy = (
  language,
  iboInfo,
  dataForm,
  selectedPlan,
  tokenVT,
  distributor
) => {
  return {
    ...dataForm,
    firstName: dataForm?.firstName ?? dataForm.nameCompanyRepresentative,
    lastName: dataForm?.lastName ?? dataForm.lastNameCompanyRepresentative,
    cityId: dataForm?.cityId ?? 0,
    AllCloser: false,
    side: 1, // Verificar 
    positioningId: 1, // Verificar
    isOnlinePayment: true,
    createdBy: iboInfo.email,
    closerId: distributor.id,
    enrollerCode: iboInfo.code,
    enrollerId: distributor.id,
    details: [
      {
        productCode: selectedPlan.code,
        price: selectedPlan.price,
      },
      {
        productCode: selectedPlan.membershipCode,
        price: selectedPlan.membershipPrice,
      },
    ],
    payment: {
      amount: selectedPlan.total,
      applicationId: APPLICATION_ID,
      contactId: iboInfo.conctactId,
      currencyCode: "USD",
      countryCode: "USA",
      language: language,
      createdBy: iboInfo.email,
      productId: 36,
      paymentType: 1,
      supplierId: 11,
      tokenVT,
      wayToPayId: dataForm.payment.paymentMethods,
      payment: {
        ...dataForm.payment,
      },
    },
  };
};

export const generateRqtMembershipCreate = (
  response,
  iboInfo,
  dataForm,
  filterPlans
) => {
  return {
    type: "1",
    isBusiness: 0,
    purchaseId: response.data.purchaseId,
    itaCode: iboInfo.code,
    countryOperationId: filterPlans.countryId,
    cityId: dataForm.cityResidence,
    indicativeId: dataForm.indicative,
    documentType: dataForm.documentType,
    document: dataForm.documentNumber,
    gender: dataForm.gender,
    name: dataForm.name,
    lastName: dataForm.lastName,
    birthDate: new Date(
      dataForm.birthYear,
      dataForm.birthMonth,
      dataForm.birthDay
    )
      .toISOString()
      .substring(0, 10),
    email: dataForm.email,
    address: dataForm.address,
    zipCode: dataForm.postalCode,
    phone: dataForm.phone,
    beneficiaryName: dataForm.beneficiaryName,
    beneficiaryLastName: dataForm.beneficiaryLastName,
    sponsor: iboInfo.code,
    center: 1,
    sideId: 1,
    enroller: iboInfo.code,
    presenter: iboInfo.code,
    isAllpresenter: 1,
    installmentNumber: 1,
    createdBy: dataForm.email,
  };
};

export const generateRqtNeoTool = (
  iboInfo,
  purchaseId,
  data_json,
  language
) => {
  return {
    itaCode: iboInfo.code,
    url: `https://foca.visiontravel.net/purchases/membership/${purchaseId}`,
    urltext: "View",
    subject: `Membership ITA ${iboInfo.code}`,
    message: `${data_json}`,
    language: language,
    guestList: [
      "a.gomez@visiontravel.net",
      "j.castrillon@visiontravel.net",
      "v.hernandez@visiontravel.net",
      "odalis@visiontravel.net",
      "d.lopez@visiontravel.net",
    ],
  };
};

export const rqtPurchaseCourse = (iboInfo, dataForm, language, purchase, payment) => {
  return {
    applicationId: APPLICATION_ID,
    contactId: iboInfo.id,
    createdBy: iboInfo.email,
    currencyCode: dataForm.currencyCode,
    countryCode: dataForm.countryCode,
    entityId: ENTITY_ID,
    identifier: purchase.purchaseId,
    language: language,
    productId: Number(PRODUCT_ID),
    supplierId: SUPPLIER_ID,
    amount: dataForm.amount,
    wayToPayId: dataForm.wayToPayId,
    payment
  }
}
